export default "__VITE_ASSET___xsp2oeP__"